import React, { useEffect, useState, useMemo, useRef } from 'react';

import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import DealDetails from './DealDetails';
import Header from './Header';
import SelectedOptions from './SelectedOptions';
import { Block } from './StyledComponents';

import * as actionTypes from '../../store/actions/index';
import Spinner from '../Spinner/Spinner';

const LocalBroker = (props) => {
  const { surveyId } = useParams();
  const [IsSpinner, SetIsSpinner] = useState(false);

  const { data, currentDeal } = props;

  console.log(surveyId);

  useEffect(() => {
    SetIsSpinner(true);
    props.setApiData(surveyId, true);

    setTimeout(() => {
      SetIsSpinner(false);
      props.updateBrokerCounter();
    }, 3000);
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (data && data.dealId) {
      props.setEmail(data.dealId);
    }

    // eslint-disable-next-line
  }, [data]);

  const handleRedirect = () => {
    window.open(currentDeal?.['SurveyLink'], '_blank');
  };

  return (
    <Container>
      <Header title={data?.survey?.Client} />
      {IsSpinner && <Spinner />}

      <TitleBlock>
        <Block display="flex" alignItems="center" position="relative">
          <Title>Agile Options</Title>
        </Block>
        <Block>
          <PrimaryButton onClick={handleRedirect}>View Client Deliverable</PrimaryButton>
        </Block>
      </TitleBlock>
      <DealDetails />
      <SelectedOptions optionData={data} setApiData={props.setApiData} />
    </Container>
  );
};
const Container = styled.div`
  background: #e5e5e5;
`;
const TitleBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 14px;
  margin-top: 30px;
  padding: 0 48px;
`;
const PrimaryButton = styled.div`
  display: flex;
  align-items: center;
  color: #003f2d;
  border: 1px solid #003f2d;
  cursor: pointer;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.02em;
  padding: 8px 16px;
  border-radius: 4px;
  text-align: center;
  &:hover {
    color: #ffffff;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)), #003f2d;
    cursor: pointer;
  }

  &:focus {
    color: #ffffff;
    background: #003f2d;
    box-shadow: 0px 0px 2px 2px #003f2d;
  }
`;

const Title = styled.div`
  font-family: 'Calibre-R';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  padding-right: 12.5px;
  color: #1a1a1a;
`;

const mapStateToProps = (state) => {
  return {
    data: state.optRed.data,
    currentDeal: state.comRed.currentDeal,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setEmail: (id) => dispatch(actionTypes.flexpertEmailAction(id, 'BROKER')),
    setApiData: async (surveyId, isShortlisted) =>
      dispatch(actionTypes.providerAction(surveyId, false, true)),
    updateBrokerCounter: () =>
      dispatch(actionTypes.updateCounter(0, 'editClientDeliverableCounter')),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocalBroker);
